import React, {Component} from 'react'
import {UserAction} from '../actions/UserAction'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {gaPageView} from "../constants";
import MatchAlertSetting from "./MatchAlertSetting";
import {Input, Modal} from 'antd';
import customerService from '../services/customer.service';
import i18n from "i18next";
import {MailOutlined, UserOutlined} from '@ant-design/icons';

class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalvisible: false,
            tabledata: [],
            tablecolumns: [
                {
                    title: 'Full Name',
                    dataIndex: 'fullName',
                    key: 'fullName',
                    render: text => <a>{text}</a>,
                },
                {
                    title: 'E-Mail',
                    dataIndex: 'email',
                    key: 'email',
                }
            ]

        }
    }

    componentDidMount() {
        gaPageView();
        // this.getUserList();
    }

    getUserList = () => {

        customerService.getUsersByCompany().then(response => {

                const tableData = response.data.map(user => {
                    return {
                        fullName: user["fullName"],
                        email: user["email"],
                        disable: "asd"
                    };

                });

                this.setState({
                    tabledata: tableData
                })

            }
        )
    }

    sendInvitation = () => {
        const {email, name} = this.state;
        const data = {email, name}

        customerService.sendInvitation(data);

    }

    showModal = () => {
        this.setState({
            modalvisible: true,
        });
    };

    handleOk = () => {

        this.sendInvitation();

        this.setState({
            modalvisible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            modalvisible: false,
        });
    };

    handleInputChange = (e) => {
        const {name, value} = e.target
        this.setState({[name]: value})
    }

    render() {

        return (
            <>
                <section className="ms-section pb-20">
                    <div className="container">

                        <div className="row justify-content-center pb-25">
                            <div className="form-box-report match-alert-setting custom-box-shadow custom-card-border">
                                <MatchAlertSetting/>
                            </div>
                        </div>

                        {/*<div className="accounts-container">*/}

                        {/*    <Button onClick={this.showModal} size='large' className='add-user-btn'>*/}
                        {/*        {i18n.t("add_user")}*/}
                        {/*    </Button>*/}

                        {/*    <div className='accounts'>*/}
                        {/*        <Table columns={this.state.tablecolumns} dataSource={this.state.tabledata} />*/}
                        {/*    </div>*/}

                        {/*</div>*/}

                    </div>
                </section>

                <Modal
                    className='user-list-modal'
                    title={i18n.t("add_user")}
                    visible={this.state.modalvisible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    cancelText={i18n.t("cancel")}
                    okText={i18n.t("send")}
                >
                    <div className='user-modal-data-container'>
                        <h4 style={{textAlign: 'center', margin: 'auto'}}>{i18n.t("enter_user_data")}</h4>
                        <Input
                            size="large"
                            name={"name"}
                            placeholder={i18n.t('name')}
                            prefix={<UserOutlined/>}
                            onChange={(e) => {
                                this.handleInputChange(e);
                            }}
                            value={this.state.name}
                        />

                        <Input
                            size="large"
                            name={"email"}
                            placeholder={i18n.t('email')}
                            prefix={<MailOutlined/>}
                            onChange={(e) => {
                                this.handleInputChange(e);
                            }}
                            value={this.state.email}
                        />
                    </div>

                </Modal>

            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        common: state.common,
        user: state.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);